import * as React from 'react';
import {useEffect} from 'react';
import {useLocation, useNavigate} from "react-router-dom";
import Top from "../Top";

import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Card from '@mui/material/Card';
import Container from "@mui/material/Container";
import Stack from "@mui/material/Stack";
import {styled} from '@mui/material/styles';
import Divider from '@mui/material/Divider';
import PhoneAndroidIcon from '@mui/icons-material/PhoneAndroid';
import EmailIcon from '@mui/icons-material/Email';
import {FormContainer, TextFieldElement} from "react-hook-form-mui";

const typeMemberProfile = {
  id: '', name: '', birthDate: '', cusId: '', phone: '', address: '', buildingNum: '', companyId: ''
  ,email: '', zipCode: '', beforePassword: '', password: '', 
  height: '', weight: '',
  interest_disease: '', is_medicine: '', work_strength: ''
};

const UserJoinContact = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const userInfo = { ...location.state };
  const [memberProfile, setMemberProfile] = React.useState(typeMemberProfile);
  
  useEffect(() => {
    setMemberProfile(userInfo);
  }, []);
  
  // 회원 추가정보를 받기 위한 화면으로 이동
  async function handleSaveUser(data :any){
    const updatedProfile = {
      ...memberProfile,
      phone: data.phone.substring(0,3) + '-' + data.phone.substring(3,7) + '-' + data.phone.substring(7,11)
    };
    
    navigate('/Join/UserJoinAddress', {state: updatedProfile});
  }

  

  return (
    <Container sx={Logbg}>
      <Top title="회원 가입" />

      <Stack direction={'column'} sx={{ justifyContent: 'center', alignContent: 'center' }}>
        <FormContainer
          values={{ email: memberProfile.email, phone: memberProfile.phone }}
          onSuccess={data => handleSaveUser(data)}
        >

          <Card sx={{ p: '0px 20px 30px 20px', bgcolor:'#fff' }}>
            <Divider  sx={{fontSize:18, mb:2, mt:2.5, fontWeight:700}}>연락처</Divider>

            <Box sx={{ display: 'flex', alignItems: 'flex-end', mb: 2 }}>
              <PhoneAndroidIcon sx={profileIcon} />
              <TextFieldElement
                name="phone"
                
                type="number"
                id="input-tel" label="휴대전화" variant="standard"
                fullWidth
                inputProps={{ maxLength: 11 }}
                rules={{
                  required: '필수 입력입니다.',
                  pattern: {
                    value: /^[0-9]{3}[0-9]{4}[0-9]{4}$/i,
                    message: '연락처 형식을 확인해주세요.',
                  },
                }}
                onChange={(e :any) => {
                  setMemberProfile((prev) => true ? {...prev, phone: e.target.value} : prev)
                }}
                sx={loginField}
              />
            </Box>
            <Box sx={{ display: 'flex', alignItems: 'flex-end', mb: 2 }}>
              <EmailIcon sx={profileIcon} />
              <TextFieldElement
                name="email"
                id="input-email" label="이메일" variant="standard"
                fullWidth
                rules={{
                  required: '필수 입력입니다.',
                  pattern: {
                    value: /^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,}$/,
                    message: '이메일 형식을 확인해주세요.',
                  },
                }}
                onChange={(e :any) => {
                  setMemberProfile((prev) => true ? {...prev, email: e.target.value} : prev)
                }}
                sx={loginField}
              />
            </Box>

          </Card>

          <Box sx={{ p: '10px 0px 30px 0px' }}>
            <Stack direction="row" justifyContent="center" alignItems="center" spacing={0} sx={{ mt: 3, bgcolor: '#ffb068', borderRadius: '20px' }}>
              <CareButton variant="contained" type={'submit'}>
                다음
              </CareButton>
            </Stack>
          </Box>
        </FormContainer>

      </Stack>
    </Container>

  );
}

const profileIcon = {
  color: '#888', mr: 1, my: 0.5, fontSize: 20
}

const CareButton = styled(Button)({
  boxShadow: 'none',
  textTransform: 'none',
  fontSize: 16,
  fontWeight: 700,
  padding: '10px 30px',
  lineHeight: 1.5,
  backgroundColor: '#EF8322',
  borderColor: '#EF8322',
  borderRadius: '20px',
  width: '100%',
  '&:hover': {
    backgroundColor: '#EF8322',
    borderColor: '#EF8322',
    boxShadow: 'none',
  },
  '&:active': {
    boxShadow: 'none',
    backgroundColor: '#EF8322',
    borderColor: '#EF8322',
  },
  '&:focus': {
    boxShadow: 'none',
  },
});

const loginField = {
  '& input': {
    fontSize: 16
  },
  '& label': {
    color: '#888',
    fontSize: 16
  },
  '& label.Mui-focused': {
    color: '#ef8322',
  },
  '& .MuiInput-underline:after': {
    borderBottomColor: '#ef8322',
  },
  '& .MuiInputBase-root:before': {
    borderBottomColor: '#bbb',
  }
};

const Logbg = {
  bgcolor: '#f6f6f6',
  height: '100%',
  minHeight: '100vh',
  pb: 4,
  minWidth: '320px',
  pt: 10,
}

export default UserJoinContact;